import { render, staticRenderFns } from "./ProposalList.vue?vue&type=template&id=0337dabc&"
import script from "./ProposalList.vue?vue&type=script&lang=js&"
export * from "./ProposalList.vue?vue&type=script&lang=js&"
import style0 from "./ProposalList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0337dabc')) {
      api.createRecord('0337dabc', component.options)
    } else {
      api.reload('0337dabc', component.options)
    }
    module.hot.accept("./ProposalList.vue?vue&type=template&id=0337dabc&", function () {
      api.rerender('0337dabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/ProposalList.vue"
export default component.exports